import { useAppSelector } from 'hooks';
import { WIP_STATUS_BINDER_PENDING_UPLOAD } from 'variables/constants';

/**
 * Hook to check if the legacy auto form is locked (submitted).
 * Use this instead of passing isLocked prop through components.
 */
export const useLegacyAutoFormLocked = (): boolean => {
  const wipStatus = useAppSelector((state) => state.legacyAutoForm.wipStatus);
  return wipStatus === WIP_STATUS_BINDER_PENDING_UPLOAD;
};
